import { querySelectorAll } from './querySelectors';

const TABLE_CLASS = 'table';
const TABLE_INIT_CLASS = 'tt-init';
const TABLE_WRAPPER_CLASS = 'w-table';

let initTable = function(table) {
  let wrapper = document.createElement('div');
  let tableFix = document.createElement('div');
  wrapper.classList.add(TABLE_WRAPPER_CLASS);
  tableFix.classList.add('w-table__fix');

  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);
  wrapper.appendChild(tableFix);
};

export function setTables() {
  let tables = querySelectorAll(`table.${TABLE_CLASS}:not(.${TABLE_INIT_CLASS})`);

  tables.forEach((table) => {
    table.classList.add(TABLE_INIT_CLASS);
    initTable(table);
  });
}
